// src/components/BottomSheetComponent.tsx
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/swiper-bundle.css"; // Swiper 스타일 import
import FadeInWrapper from "../../../../components/common/fade-in-wrapper";
import { Swiper as SwiperType } from "swiper/types";
import { useNavigate } from "react-router-dom";
import BottomSheet from "../../../../components/common/bottom-sheet";
import INTRO_IMG1 from "../image/1.png";
import INTRO_IMG2 from "../image/2.png";
import INTRO_IMG3 from "../image/3.png";

interface GuideBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  currentSlide: number;
  setCurrentSlide: (index: number) => void;
}

const GuideBottomSheet: React.FC<GuideBottomSheetProps> = ({
  isOpen,
  onClose,
  currentSlide,
  setCurrentSlide,
}) => {
  const navigate = useNavigate();
  if (!isOpen) return null; // BottomSheet가 열려있지 않으면 아무것도 렌더링하지 않음
  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      buttonText="확인"
      onButtonClick={onClose}
    >
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        onSlideChange={(swiper: SwiperType) =>
          setCurrentSlide(swiper.activeIndex)
        }
      >
        <SwiperSlide>
          <div>
            <FadeInWrapper className="flex items-start">
              <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
                1
              </div>
              <h1 className="text-2xl font-bold">
                손님이 매장을 보고 <br /> 오늘 나올 랜덤 마감팩을 <br /> 미리
                결제하고 기다려요
              </h1>
            </FadeInWrapper>
            <div className="flex justify-center items-center h-48">
              <img src={INTRO_IMG1} alt="예약 판매 안내" className="max-h-56" />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div>
            <FadeInWrapper className="flex items-start">
              <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
                2
              </div>
              <h1 className="text-2xl font-bold">
                오늘 남았으면 팔고, <br /> 안남았으면 취소해도돼요!
              </h1>
            </FadeInWrapper>
            <div className="flex items-start">
              <p className="text-lg text-red-500 ml-10">
                취소하지 않으면 자동 확정됩니다!
              </p>
            </div>
            <div className="flex justify-center items-center h-48">
              <img
                src={INTRO_IMG2}
                alt="슬라이드 2 이미지"
                className="max-h-56"
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div>
            <FadeInWrapper className="flex items-start">
              <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
                3
              </div>
              <h1 className="text-2xl font-bold">
                손님이 도착하면
                <br /> 랜덤팩을 전달해요!
              </h1>
            </FadeInWrapper>
            <div className="flex items-start">
              <p className="text-lg text-gray-500 ml-10">
                가격에 맞게 소분만 해서 전달하면 돼요!
              </p>
            </div>
            <div className="flex justify-center items-center h-48">
              <img
                src={INTRO_IMG3}
                alt="슬라이드 3 이미지"
                className="max-h-56"
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div>
            <FadeInWrapper className="flex items-start">
              <h1 className="text-2xl font-bold">더 자세하게 궁금하다면?</h1>
            </FadeInWrapper>
            <div className="flex flex-col justify-center items-center h-48 overflow-y-auto">
              <button
                onClick={() => navigate("/boss/pre-order/faq")}
                className="text-white rounded-xl border px-4 py-2 bg-blue-500 font-semibold mt-4"
              >
                자주묻는질문 이동하기 (클릭)
              </button>
              <div className="text-lg text-gray-500 text-center mt-4">
                ⬆️ 더 자세한 <br />
                이야기들을 담았어요!
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>

      {/* 수동 페이지네이션 점 */}
      <div className="flex justify-center mt-4">
        {[0, 1, 2, 3].map((index) => (
          <div
            key={index}
            className={`w-3 h-3 mx-1 rounded-full ${
              currentSlide === index ? "bg-blue-500" : "bg-gray-300"
            }`}
          />
        ))}
      </div>
    </BottomSheet>
  );
};

export default GuideBottomSheet;
